import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import ScoreReportRenderer from '../components/test-prep/ScoreReportRenderer';

export default function TestScoreReportPage() {
  const { domain, sessionId } = useParams();
  const navigate = useNavigate();

  const handleNavigate = (target) => {
    if (target === 'test_review') {
      navigate(`/tests/${domain}/review/${sessionId}`);
    } else if (target === 'test_list') {
      navigate(`/tests/${domain}`);
    } else if (target === 'score_history') {
      navigate(`/tests/${domain}`);
    }
  };

  return (
    <ScoreReportRenderer
      scene={{
        session_id: sessionId,
        domain_id: domain,
        onNavigate: handleNavigate,
      }}
    />
  );
}
